import React from "react";
import PropTypes from "prop-types";
import { 
    OrderedMap,
} from "immutable";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col, Card, Icon, Statistic, message } from "antd";
import RetailerRiskControlForm from "../../forms/retailer-risk-control-form";
import {
    STATE_STATUS,
} from "../../constants";
import { fetchRetailerRiskControlDetail, updateRetailerRiskControlDetail } from "store/actions";

const getProfileLayout = data => new OrderedMap({
    max_ticket_size_db: {
        span: 6,
        key: "max_ticket_size_db",
        label: "Max Ticket Size Allowed(For DB)",
        value: data?.proposed_max_ticket_size_in_lacs,
        type: "card"
    },
});



class RetailerRiskControl extends React.Component {

    formRef = React.createRef();
    componentDidMount() {
        this.props.fetchRetailerRiskControlDetail(this.props.caseId, this.props.companyId)
    }


    componentDidUpdate(prevProps) {
        console.log("this.props.retailerRiskControlStatus", this.props.retailerRiskControlStatus)
        console.log('prevProps.retailerRiskControlStatus', prevProps.retailerRiskControlStatus);
        if(this.props.retailerRiskControlStatus  == STATE_STATUS.UPDATED && prevProps.retailerRiskControlStatus == STATE_STATUS.UPDATING) {
            this.props.fetchRetailerRiskControlDetail(this.props.caseId, this.props.companyId)
        }
    }
    onValuesSubmit = (values) => {
        const case_id = this.props.caseId;
        const method = (this.props.caseDetail.extra_data && this.props.caseDetail.extra_data['mpa']) ? 'put' : 'post'
        const t = this;
        const { program_type = null, proposed_max_ticket_size_in_lacs = null, proposed_program_size_in_cr = null } = Array.isArray(this.props.retailerRiskControlData) ? this.props.retailerRiskControlData[0] : this.props.retailerRiskControlData || {};
        const retailerRiskControlBody = {
            case_id,
            // program_type,
            // proposed_max_ticket_size_in_lacs,
            // proposed_program_size_in_cr,
            ...values
        }
        t.props.updateRetailerRiskControlDetail(case_id, retailerRiskControlBody , method);
    }

    getLoading() {
        const status = this.props.profile && this.props.profile.get("status");
        if (status === STATE_STATUS.UPDATING || status === STATE_STATUS.FETCHING) {
            return true;
        }
        return false;
    }
    render() {
        return <Row>
            <Col span={24} offset={3} className={"pb-5"}>
                <Row gutter={24}>
                    {
                        getProfileLayout(Array.isArray(this.props.retailerRiskControlData) ? this.props.retailerRiskControlData[0]: this.props.retailerRiskControlData).map(_ =>
                            (
                                <Col key={_.key} span={_.span}>
                                    <Card title={null} className={"border-none"} size={"default"} >
                                        <Statistic
                                            valueStyle={{
                                                fontSize: "16px",
                                                fontWeight: 500
                                            }}
                                            title={_?.label}
                                            value={_?.value || "--"} 
                                        />
                                    </Card>
                                </Col>
                            )
                        ).toList()
                    }
                </Row>
            </Col>
            <Col span={18} offset={3}>
                <RetailerRiskControlForm
                    retailerRiskControlData={this.props.retailerRiskControlData}
                    onValuesSubmit={this.onValuesSubmit}
                    loading={this.getLoading()}
                    disableFields={this.props.stageId !== 7}
                    companyId={this.props.companyId}
                    caseId={this.props.case_id}
                />
            </Col>
        </Row>;
    }
}


RetailerRiskControl.propTypes = {
    // fetchRetailerRiskControlDetail: PropTypes.func,
    // updateRetailerRiskControlDetail: PropTypes.func,
};

const mapStateToProps = (state, props) => {
    return {
        retailerRiskControlData: state.retailerRiskControlData.get('retailer_risk_control_data'),
        retailerRiskControlStatus: state.retailerRiskControlData.get('retailer_risk_control_status'),
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchRetailerRiskControlDetail,
            updateRetailerRiskControlDetail
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RetailerRiskControl);

